import { ChangeEvent, InputHTMLAttributes, ReactNode } from "react"
import { css, cx } from "@emotion/css"

const styles = {
  hidden: css`
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap; /* added line */
  `,
  root: css`
    :not(:last-of-type) {
      margin-bottom: var(--spacing-xxs);
    }
  `,
  box: css`
    max-width: 200px;
    padding: var(--spacing-xs) var(--spacing-m);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    cursor: pointer;
    background-color: var(--light-grey-2);
    border-radius: 2px;
    text-decoration: none;
  `,

  label: css`
    width: 100%;
  `,
  input: css`
    :focus + .box {
      color: #171414;
    }

    :checked + .box {
      background-color: var(--primary-light);
      > div > div {
        font-weight: 400;
      }
    }

    :disabled + .box {
      cursor: not-allowed;
      opacity: 0.5;
    }
  `,
}

export type CheckListItemProps = {
  value: string
  label: ReactNode
  searchLabel?: string
  checked?: boolean
  filteringValue?: string
  setValue?: (name: string, value: string) => void
  resetSearch?: (val: string) => void
  index?: number
} & InputHTMLAttributes<HTMLInputElement>

export function CheckListItem(props: CheckListItemProps) {
  const {
    className,
    label,
    onChange,
    checked,
    setValue,
    value,
    name,
    id,
    disabled,
    resetSearch,
    index = 0,
  } = props

  const moddedIndex = 1 + index
  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target
    if (setValue) {
      resetSearch?.("")
      setValue(name, value)
    } else if (onChange) {
      onChange(evt)
      resetSearch?.("")
    } else {
      //
    }
  }
  return (
    <div
      data-testid={`filtered-${name
        ?.toLowerCase()
        ?.replaceAll("_", "-")}-${moddedIndex}`}
      className={cx(styles.root, className)}
    >
      <label htmlFor={id} className={styles.label}>
        <input
          className={cx(styles.hidden, styles.input)}
          type="checkbox"
          name={name}
          checked={checked}
          id={id}
          value={value}
          onChange={handleChange}
          disabled={disabled}
        />
        <div className={cx("BodyBody-2BlackLight", styles.box, "box")}>
          {label}
        </div>
      </label>
    </div>
  )
}
